import {
    GET_URPAYCONFIG_LOADING,
    GET_URPAYCONFIG_SUCCESS,
    GET_URPAYCONFIG_FAILED,
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    merchantsConfig: null,
    status:null
  };
  
  export const geturpayConfigReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any, status:any }
  ) => {

    switch (action.type) {
      case GET_URPAYCONFIG_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
        };
      case GET_URPAYCONFIG_SUCCESS:
        return {
          ...state,
          loading: false,
          merchantsConfig:action.payload,
          error: null,
          status:action.status
        };
      case GET_URPAYCONFIG_FAILED:
        return {
          ...state,
          loading: false,
          error: action.error,
          status:action.status,
        };
      
      default:
        return state;
    }
  };
  